export default "__VITE_ASSET__BgQdpX3c__"